"use client";

// « Vous payez en tant que : Particulier | Entreprise », en tête de la
// facturation d'un achat (tunnel d'abonnement, achat à vie). Particulier par
// défaut : rien de plus à remplir pour qui paie pour lui-même.
//
// tone : « light » pour le tunnel de paiement, toujours clair (palette stone,
// sans variantes sombres) ; « auto » ailleurs (mode sombre).

import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

const TONES = {
    light: {
        track: "bg-stone-100",
        on: "bg-white text-stone-900 shadow-sm",
        off: "text-stone-500 hover:text-stone-800",
    },
    auto: {
        track: "bg-gray-100 dark:bg-white/5",
        on: "bg-white text-gray-900 shadow-sm dark:bg-white/10 dark:text-white",
        off: "text-gray-500 hover:text-gray-900 dark:text-grayDark-400 dark:hover:text-white",
    },
};

const MODES = [
    { id: "individual", icon: "user-linear", labelKey: "billing_mode_individual" },
    { id: "company", icon: "buildings-2-linear", labelKey: "billing_mode_company" },
];

export default function BillingModeSwitch({ company, onChange, tone = "auto" }) {
    const t = useTranslations();
    const styles = TONES[tone] || TONES.auto;

    return (
        <div
            role="radiogroup"
            aria-label={t("billing_mode_label")}
            className={`grid grid-cols-2 gap-1 rounded-xl p-1 ${styles.track}`}
        >
            {MODES.map((mode) => {
                const checked = (mode.id === "company") === company;
                return (
                    <button
                        key={mode.id}
                        type="button"
                        role="radio"
                        aria-checked={checked}
                        onClick={() => onChange(mode.id === "company")}
                        className={`flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-[13px] font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary/40 ${
                            checked ? styles.on : styles.off
                        }`}
                    >
                        <SolarIcon name={mode.icon} className="text-base" />
                        {t(mode.labelKey)}
                    </button>
                );
            })}
        </div>
    );
}
